// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { gridTwoByTwo16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-grid-two-by-two': IconGridTwoByTwo;
    }
}

/**
 * The icon component for the 'gridTwoByTwo' icon
 */
export class IconGridTwoByTwo extends Icon {
    public constructor() {
        super(gridTwoByTwo16X16);
    }
}

registerIcon('icon-grid-two-by-two', IconGridTwoByTwo);
export const iconGridTwoByTwoTag = 'nimble-icon-grid-two-by-two';
